import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SelectableQualificationDatum } from '@ps/survey-utils';

import { LocationConditionsApi } from '../../api/location-conditions/location-conditions.api';

@Injectable({ providedIn: 'root' })
export class LocationConditionsService {
  private readonly _api = inject(LocationConditionsApi);

  public getAll(
    dbQualificationCode: number,
    locale: string,
  ): Observable<SelectableQualificationDatum[]> {
    return this._api.getAll(dbQualificationCode, locale);
  }
}
